import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const AccommodationModal = ({ isOpen, onClose, onSave, dayNumber, editingAccommodation }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    checkIn: '02:00 PM',
    checkOut: '12:00 PM',
    cost: 0
  });

  useEffect(() => {
    if (editingAccommodation) {
      setFormData(editingAccommodation);
    } else {
      setFormData({
        name: '',
        address: '',
        checkIn: '02:00 PM',
        checkOut: '12:00 PM',
        cost: 0
      });
    }
  }, [editingAccommodation]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave(dayNumber, formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card rounded-xl border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">
              {editingAccommodation ? 'Edit Accommodation' : 'Add Accommodation'}
            </h2>
            <p className="text-sm text-muted-foreground mt-1">Day {dayNumber}</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <Input
            type="text"
            label="Hotel/Resort Name"
            required
            value={formData?.name}
            onChange={(e) => handleChange('name', e?.target?.value)}
            placeholder="e.g., Boracay Beach Resort"
          />

          <Input
            type="text"
            label="Address"
            required
            value={formData?.address}
            onChange={(e) => handleChange('address', e?.target?.value)}
            placeholder="e.g., Station 2, White Beach"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Input
              type="text"
              label="Check-in Time"
              required
              value={formData?.checkIn}
              onChange={(e) => handleChange('checkIn', e?.target?.value)}
              placeholder="e.g., 02:00 PM"
            />

            <Input
              type="text"
              label="Check-out Time"
              required
              value={formData?.checkOut}
              onChange={(e) => handleChange('checkOut', e?.target?.value)}
              placeholder="e.g., 12:00 PM"
            />
          </div>

          <Input
            type="number"
            label="Cost per Night (₱)"
            required
            value={formData?.cost}
            onChange={(e) => handleChange('cost', parseFloat(e?.target?.value) || 0)}
            placeholder="0"
            min="0"
            step="0.01"
          />

          {/* Actions */}
          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              size="lg"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              size="lg"
              fullWidth
              iconName="Save"
              iconPosition="left"
            >
              {editingAccommodation ? 'Update Accommodation' : 'Add Accommodation'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccommodationModal;